import { IModuleProps } from '../core/utils/modules';

import routes from './routes';

export default {
    name: 'teams',
    routes,
} as IModuleProps;
